import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'contact-forms' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
